module.exports = __webpack_public_path__ + "assets/img/walletBg2.dccd7693.png";